import { render, staticRenderFns } from "./DashboardHealthTrend.vue?vue&type=template&id=3b5ee8ec&scoped=true"
import script from "./DashboardHealthTrend.vue?vue&type=script&lang=js"
export * from "./DashboardHealthTrend.vue?vue&type=script&lang=js"
import style0 from "./DashboardHealthTrend.vue?vue&type=style&index=0&id=3b5ee8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5ee8ec",
  null
  
)

export default component.exports